<template>
    <div class="contain">
      <div class="topTitle flex">
        <span class="preview">页面分析</span>
        <el-select
          v-model="region"
          placeholder="请选择商户"
          @change="MerchSelete"
          style="width: 200px"
        >
          <el-option v-for="(item,index) in seleteAppList" :key="index" :label="item.nickName" :value="index"></el-option>
        </el-select>
      </div>
      <div class="from">
           <div class="introduce flex">
              <span>页面分析：可查看任意1、7、30天受访页面浏览数据。</span>
              <span>受访页：用户进入小程序浏览过的所有页面，例如用户从页面A进入小程序，跳转到页面B，A,B均为浏览页。受访页面的访问次数、用户数和平均访问时长，可以了解用户使用最多的页面，以及使用时长的情况。</span>
           </div>
            <div class="searchTime">
              <div class="seleSearchTime flex">
                <div class="pressActive flex flex-center item-center" :class="[item.checked ?'activers':'']" @click="seletesTimes(index)" v-for="(item,index) in seleButton" :key="index">
                    <span class="copywriting" :class="[item.checked ?'active':'']">{{item.name}}</span>
                </div>
                <el-date-picker
                      v-model="value1"
                      @change="change"
                      type="daterange"
                      value-format="yyyy-MM-dd"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期">
                  </el-date-picker>
                <div class="searchStyle">
                  <el-input style="width: 240px"
                      placeholder="请输入页面路径查询"
                      v-model="searchViewPath"
                      clearable>
                  </el-input>
                  <el-button class="buttonStyle" type="primary" @click="search"
                  >查询</el-button
                  >
                </div>
              </div>
          </div>
           <div class="tabFrom">
           <el-table

            stripe
            border
            @sort-change="changeTableSort"
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            id="table"
            size="small"
            >
            <el-table-column key="1" prop="pageName" label="页面名称" :sortable="'custom'" width="180" align="center"></el-table-column>
            <el-table-column key="2" prop="pagePath" label="路径"  width="180" align="center"></el-table-column>
            <el-table-column key="3" prop="pageVisitPv" label="访问次数" :sortable="'custom'" align="center"></el-table-column>
            <el-table-column key="4" prop="pageVisitUv" :sortable="'custom'" label="访问人数" align="center"></el-table-column>
            <el-table-column key="5" prop="pageStaytimePv" :sortable="'custom'" label="次均使用时长(s)" align="center"></el-table-column>
            <el-table-column key="6" prop="entrypagePv" :sortable="'custom'" label="进入页次数" align="center"></el-table-column>
            <el-table-column key="7" prop="exitpagePv" :sortable="'custom'" label="退出页次数" align="center"></el-table-column>
            <el-table-column key="8" prop="address" :sortable="'custom'" label="退出率" align="center"></el-table-column>
            <el-table-column key="9" prop="pageSharePv" :sortable="'custom'" label="分享次数" align="center"></el-table-column>
            <el-table-column key="10" prop="pageShareuv" :sortable="'custom'" label="分享人数" align="center"></el-table-column>
        </el-table>
      </div>

      <div class="hm-pagination mb20">
        <el-pagination
          background
          :total="uploadedMpTempListTotal"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pageNo"
        ></el-pagination>
      </div>
      </div>
    </div>
</template>

<script>

export default {
  data(){
      return {
        value1: null,
        pageNo: 1,
        pageSize: 10,
        region: 'hemiaomall（推金库 测试小程序）',
        seleteAppList: [],
        tableData: [],
        timesList: [],
        orderByType: null,  // 倒序  还是正序
        orderBy: null, //
        seleteIndex:0,
        initiali:{},
        uploadedMpTempListTotal: 0,
        yesterday:'', // 昨天
        week:'',   //  周
        today: '', // 今天
        month: '', // 过去30天
        seleButton: [
            {
                name: '昨天',
                checked: true
            },
            {
                name: '过去7天',
                checked: false
            },
             {
                name: '过去30天',
                checked: false
            }
        ],
        searchViewPath: ""
      }
  },
  created(){
      let curDate = new Date();
      var nowDate = curDate.getTime();
      var preDate = new Date(curDate.getTime() - 24*60*60*1000); //前一天
      var week = new Date(curDate.getTime() - 24*60*60*1000*7); // 过去7天
      var month = new Date(curDate.getTime() - 24*60*60*1000*30); // 过去30天
      this.today = this.formatDateTime(curDate)
      this.yesterday =this.formatDateTime(preDate)
      this.week = this.formatDateTime(week)
      this.month =  this.formatDateTime(month)
      this.getSeleteWechat()
      this.value1 = [this.yesterday,this.yesterday]
  },
  methods: {
    search() {
      let i =this.seleButton.findIndex(item => item.checked)
      let starTimes = "";
      let endTimes = "";
      if(i !== -1){
        if(i === 0){
          starTimes = this.yesterday;
          endTimes = this.yesterday;
        }else if(i === 1){
          starTimes = this.week;
          endTimes = this.yesterday;
        }else if(i === 2){
          starTimes = this.month;
          endTimes = this.yesterday;
        }
      }else {
        starTimes = this.timesList[0];
        endTimes = this.timesList[1];
      }
      this.getDataListLeng(starTimes,endTimes);
      this.get_init(starTimes,endTimes)
    },
      formatter(row, column) {
        return row.address;
      },
      async get_init(star,end){
          const { result } = await this.$store.dispatch("queryAllDayView",{
            pageNo:this.pageNo,
            pageSize: this.pageSize,
            orderBy: this.orderBy,
            orderByType: this.orderByType,
            busType: this.initiali.miniProgramType,
            queryEndDate: end,
            queryStartDate: star,
            storeCode: this.initiali.storeCode,
            pagePath: this.searchViewPath
          });
          this.tableData = result
      },
      seletesTimes(index){
      this.searchViewPath = "";
          this.seleButton.forEach(item => {
              item.checked = false
          })
          this.seleButton[index].checked = !this.seleButton[index].checked
          if(index === 0){ // 获取昨天
            this.get_init(this.yesterday,this.yesterday)
            this.getDataListLeng(this.yesterday,this.yesterday)
            this.value1 = [this.yesterday,this.yesterday]
          }else if(index === 1){ // 获取一周
          this.value1 = [this.week,this.yesterday]
            this.get_init(this.week,this.yesterday)
            this.getDataListLeng(this.week,this.yesterday)
          }else if(index === 2) { // 获取一月
          this.value1 = [this.month,this.yesterday]
             this.get_init(this.month,this.yesterday)
             this.getDataListLeng(this.month,this.yesterday)
          }
      },
      async getSeleteWechat(){
         const { result } = await this.$store.dispatch("queryWechatSelete",{});
         this.seleteAppList = result
         this.initiali = result[0]
         this.region = this.initiali.nickName
         this.getDataListLeng(this.yesterday,this.yesterday)
         this.get_init(this.yesterday,this.yesterday)
      },
      async getDataListLeng(star,end){
          const { result } = await this.$store.dispatch("queryWechatoal",{
            orderBy: this.orderBy,
            orderByType: this.orderByType,
            busType: this.initiali.miniProgramType,
            queryEndDate: end,
            queryStartDate: star,
            storeCode: this.initiali.storeCode,
            pagePath: this.searchViewPath
          });
          this.uploadedMpTempListTotal = result
      },
      paging(page) {
        this.pageNo = page;
         var i =this.seleButton.findIndex(item => item.checked)
          var starTimes = '';
          var endTimes = '';
          if(i !== -1){
            if(i === 0){
            starTimes = this.yesterday
            endTimes = this.yesterday
            }else if(i === 1){
              starTimes = this.week
              endTimes = this.yesterday
            }else if(i === 2){
              starTimes = this.month
              endTimes = this.yesterday
            }
          }else {
            starTimes = this.timesList[0]
            endTimes = this.timesList[1]
          }
        this.get_init(starTimes,endTimes)
      },
      querySsary(){
          var i =this.seleButton.findIndex(item => item.checked)
          var starTimes = '';
          var endTimes = '';
          if(i !== -1){
            if(i === 0){
            starTimes = this.yesterday
            endTimes = this.yesterday
            }else if(i === 1){
              starTimes = this.week
              endTimes = this.yesterday
            }else if(i === 2){
              starTimes = this.month
              endTimes = this.yesterday
            }
          }else {
            starTimes = this.timesList[0]
            endTimes = this.timesList[1]
          }
        this.get_init(starTimes,endTimes)
        this.getDataListLeng(starTimes,starTimes)
      },
      handleSizeChange(size) {
        this.pageNo = 1;
        this.pageSize = size;
        var i =this.seleButton.findIndex(item => item.checked)
        console.log(i)
        var starTimes = '';
        var endTimes = '';
        if(i !== -1){
           if(i === 0){
          starTimes = this.yesterday
          endTimes = this.yesterday
          }else if(i === 1){
            starTimes = this.week
            endTimes = this.yesterday
          }else if(i === 2){
            starTimes = this.month
            endTimes = this.yesterday
          }
        }else {
           starTimes = this.timesList[0]
           endTimes = this.timesList[1]
        }

        this.orderBy = e.prop
        if(e.order === 'ascending'){
            this.orderByType = 'asc'
        }else {
          this.orderByType = 'desc'
        }
        this.tableData = []
        this.pageNo = 1
        this.get_init(starTimes,endTimes)
      },
      MerchSelete(e){
        this.searchViewPath = "";
        let index = e
        this.initiali = this.seleteAppList[index]
        this.querySsary()
      },
      changeTableSort(e){

        // 获取当前的时间  与结束时间
        var i =this.seleButton.findIndex(item => item.checked)
        console.log(i)
        var starTimes = '';
        var endTimes = '';
        if(i !== -1){
           if(i === 0){
          starTimes = this.yesterday
          endTimes = this.yesterday
          }else if(i === 1){
            starTimes = this.week
            endTimes = this.yesterday
          }else if(i === 2){
            starTimes = this.month
            endTimes = this.yesterday
          }
        }else {
           starTimes = this.timesList[0]
           endTimes = this.timesList[1]
        }

        this.orderBy = e.prop
        if(e.order === 'ascending'){
            this.orderByType = 'asc'
        }else {
          this.orderByType = 'desc'
        }
        this.tableData = []
        this.pageNo = 1
        this.get_init(starTimes,endTimes)
        // this.getDataListLeng(starTimes,starTimes)
      },
      formatDateTime (date) {
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        var h = date.getHours();
        h=h < 10 ? ('0' + h) : h;
        var minute = date.getMinutes();
        minute = minute < 10 ? ('0' + minute) : minute;
        var second=date.getSeconds();
        second=second < 10 ? ('0' + second) : second;
        return y + '-' + m + '-' + d;
        },
      change(e){
          this.timesList = e
          if(e){ // 表示用户已经选择时间
            this.seleButton.forEach(item => {
              item.checked = false
            })
          }

          this.get_init(e[0],e[1])
      },
      getNowFormatDate() {
        var date = new Date();
        var seperator1 = "-";
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
        }
        var currentdate = year + seperator1 + month + seperator1 + strDate;
        return currentdate;
    }
  }
};
</script>

<style lang="scss" scoped>
.contain{

  flex-direction: column;
  .topTitle {
    background: #fff;
    margin-bottom: 10px;
    padding: 20px;
    align-items: center;
    justify-content: space-between;
    // align-items: center;
    // border-bottom: 1px solid #e5e9f2;
    .preview {
      color: #222222;
      font-weight: 500;
      font-size: 26;
    }
  }
  .from{
    padding: 20px;
    background: #FFFFFF;
    .introduce{
      padding: 20px;
      font-size: 14px;
      border: 1px solid #FF7F10;
      color: #FFB06A;
      flex-direction: column;
      background: #FFFFEE;
    }
    .searchTime{
      width: 100%;
      margin-top: 20px;
      .seleSearchTime{
          justify-content: flex-end;
          .pressActive{
              width: 90px;
              height: 40px;
              background: #FFFFFF;
              border: 1px solid #DCDFE6;
              cursor: pointer;
              .copywriting{
                  color: #000;
                  font-size: 14px;
                  &.active{

                      color: #FFFFFF;
                  }
              }
              &.activers{
                  background: #E50163;
              }
          }
      }
  }
  .tabFrom{
    margin-top: 20px;
  }
  }
  .searchStyle {
    margin-left: 10px;
    .buttonStyle {
      margin-left: 20px;
    }
  }
}
</style>
